import PortfolioWidget from './PortfolioWidget'

export default PortfolioWidget
